/**
 * Fallback for the footer's Klaviyo signup embed.
 *
 * Klaviyo's onsite script is loaded separately (via a Shopify app embed, not this
 * theme) and injects the actual form into the container client-side. If that
 * script never fires — the app embed is off, the request is blocked, or the
 * form ID is wrong — the container stays permanently empty with no signal to the
 * visitor. After a timeout, reveal the native Shopify signup form instead so
 * there's always a working way to subscribe.
 */
(function () {
  'use strict';

  var FALLBACK_TIMEOUT_MS = 8000;

  document.querySelectorAll('[data-bj-klaviyo-wrapper]').forEach(function (wrapper) {
    var container = wrapper.querySelector('[data-bj-klaviyo-container]');
    var fallback = wrapper.querySelector('[data-bj-klaviyo-fallback]');

    if (!container || !fallback) {
      return;
    }

    window.setTimeout(function () {
      if (container.children.length === 0) {
        container.hidden = true;
        fallback.hidden = false;
      }
    }, FALLBACK_TIMEOUT_MS);
  });
})();
